import { Component, Input } from '@angular/core';

import { EmojiComponent } from '@recruitee/symbol';
import { ButtonComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-reaction-button',
  templateUrl: './reaction-button.component.html',
  styleUrls: ['./reaction-button.component.less'],
  standalone: true,
  imports: [ButtonComponent, EmojiComponent],
})
export class ReactionButtonComponent {
  @Input() public reaction: string;
  @Input() public counter: number;
  @Input() public isActive: boolean;
}
